import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../UserAccountLinker.module.scss";

const JwtExpired = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.statusCard}>
      <h2>{t("invite.expired_title")}</h2>
      <p>
        {t("invite.expired_message")}
      </p>
    </div>
  );
};

export default JwtExpired;
